module.exports = __webpack_public_path__ + "static/art-1-24d78a88d64df891b74b1fa5ce4b4071.jpg";